import {Component, OnInit} from '@angular/core';
import {IYii} from '../../../globals';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {FormsModule} from '@angular/forms';
import {SystemService} from '../services/SystemService';
import {IGQLChainShort} from '@betterchains/bc-gql';
import {MessageService} from 'primeng/api';
import {AssignmentService} from '../services/AssignmentService';
import {FormService} from '../services/FormService';
import {NgSelectComponent} from '@ng-select/ng-select';
import {Button} from 'primeng/button';

declare var Yii: IYii;

@Component({
  template: `
<div style="margin-bottom: 20px">
    <ng-select
      [items]="chains"
      bindLabel="name"
      appendTo=".p-dialog"
      [(ngModel)]="assignChainObj.chainToAssign"
      ></ng-select>
    @if(!validation.isValid) {
      <div class="error red" style="text-align: center">{{validation.message}}</div>
    }
</div>
<div style="display: flex; justify-content: flex-end; gap: 1rem">
  <p-button label="Assign" (onClick)="assignChain()"></p-button>
  <p-button severity="secondary" label="Cancel" (onClick)="close()"></p-button>
</div>
  `,
  imports: [
    FormsModule,
    NgSelectComponent,
    Button
  ]
})
export class AssignChainDialog implements OnInit {

  Yii = Yii
  assignChainObj = {
    chainToAssign: null as { name: string } | null
  }
  validation = {
    isValid: true,
    message: ""
  }

  chains: IGQLChainShort[] = []

  constructor(
    public sysvc: SystemService,
    private toast: MessageService,
    private ref: DynamicDialogRef,
    private asvc: AssignmentService,
    private fsvc: FormService
  ) {
    this.chains = this.sysvc.chains;
  }

  ngOnInit(): void {
  }

  close() {
    this.ref.close();
  }

  private DoChainToAssign(chainObjToAssign: any) {

    if (typeof chainObjToAssign == "undefined" || !chainObjToAssign) {
      return false;
    }
    let isUnique = true;
    this.fsvc.form_json.assignedChains.forEach(function (assignedChainModel: any) {
      if (parseInt(chainObjToAssign.chain_id) == parseInt(assignedChainModel.chain_id)) {
        isUnique = false;
      }
    });

    if (!isUnique) {
      return false;
    }

    this.asvc.currentChainId = chainObjToAssign.chain_id;
    this.asvc.OnChainChanged.emit(chainObjToAssign.chain_id);
    this.asvc.AddAssignment(chainObjToAssign.chain_id, 0)
    this.asvc.OnChainAssigned.emit(chainObjToAssign.chain_id);

    this.sysvc.chains.forEach((chainModel: any) => {
      if (parseInt(chainModel.chain_id) == parseInt(chainObjToAssign.chain_id)) {
        this.fsvc.form_json.assignedChains.push(chainModel);
        this.toast.add({severity: 'success', summary: Yii.t('app', 'Chain was successfully assigned')});
      }
    });
    return true;
  }

  assignChain() {
    this.validation.message = '';
    this.validation.isValid = true;

    if (typeof this.assignChainObj == "undefined"
      || typeof this.assignChainObj.chainToAssign == "undefined"
      || !this.assignChainObj.chainToAssign
    ) {
      this.validation.isValid = false;
      this.validation.message = Yii.t('app', ' Please, select some Chain from the list.');
    }

    this.validation.isValid = this.validation.isValid ? this.DoChainToAssign(this.assignChainObj.chainToAssign) : false;

    if (!this.validation.isValid && this.validation.message.trim() == '') {
      if (this.assignChainObj.chainToAssign !== null) {
        this.validation.message = Yii.t('app', 'This chain ' + this.assignChainObj.chainToAssign.name
          + ' has been already assigned. Please, select some another Chain.'
        );
      }
    }

    if (this.validation.isValid) {
      this.close()
    }
  }

}
